import { MinimalLocationInfo } from "@/models/location/MinimalLocationInfo";

export class RegionInfo {
    id:number = -1;
    name:string = "";
    syncId:string = "";
    locations:Array<MinimalLocationInfo> = [];
}
